export const RESTAURANT = {
  name: 'Sankalp Restaurant',
  location: 'Sunshine Coast',
  fullName: 'Sankalp Restaurant Sunshine Coast',
  tagline: 'The Taste of India',
  address: '74 Kingsford Smith Parade, Maroochydore QLD 4558',
  phone: '(07) 5370 8241',
  phoneRaw: '+61753708241',
  orderUrl: 'https://waiterman.ai/sankalpsunshine/order',
  bookUrl: 'https://waiterman.ai/sankalpsunshine/book',
  logoUrl:
    'https://customer-assets.emergentagent.com/job_dine-sankalp/artifacts/yfrqsgip_Screenshot_9.png',
  mapsEmbed:
    'https://www.google.com/maps?q=74+Kingsford+Smith+Parade,+Maroochydore+QLD+4558&output=embed',
  mapsDirections:
    'https://www.google.com/maps/dir/?api=1&destination=74+Kingsford+Smith+Parade+Maroochydore+QLD+4558',
};

export const MENU_CATEGORIES = [
  {
    id: 'dosas',
    name: 'Signature Dosas',
    description: 'Crispy, golden, hand-spread — our most loved.',
    img: 'https://images.pexels.com/photos/32229637/pexels-photo-32229637.png',
  },
  {
    id: 'idli-vada',
    name: 'Idli & Vada',
    description: 'Steamed, soft and served with sambar.',
    img: 'https://images.pexels.com/photos/37867687/pexels-photo-37867687.jpeg',
  },
  {
    id: 'uttapam',
    name: 'Uttapam',
    description: 'Thick savoury pancakes, loaded with veggies.',
    img: 'https://images.pexels.com/photos/38201893/pexels-photo-38201893.png',
  },
  {
    id: 'biryani',
    name: 'Biryani',
    description: 'Layered basmati, saffron and warming spice.',
    img: 'https://images.pexels.com/photos/28909536/pexels-photo-28909536.jpeg',
  },
  {
    id: 'curries',
    name: 'Curries',
    description: 'Slow-simmered, aromatic, deeply spiced.',
    img: 'https://images.pexels.com/photos/14691481/pexels-photo-14691481.png',
  },
  {
    id: 'tandoori',
    name: 'Tandoori Specials',
    description: 'Charred over live flame in clay tandoor.',
    img: 'https://images.pexels.com/photos/37076319/pexels-photo-37076319.jpeg',
  },
  {
    id: 'indo-chinese',
    name: 'Indo-Chinese',
    description: 'Wok-fired with bold Indian heat.',
    img: 'https://images.unsplash.com/photo-1585032226651-759b368d7246?w=1200&q=80',
  },
  {
    id: 'desserts-drinks',
    name: 'Desserts & Drinks',
    description: 'Gulab jamun, mango lassi, masala chai.',
    img: 'https://images.pexels.com/photos/9198596/pexels-photo-9198596.jpeg',
  },
];

export const GALLERY = [
  { url: 'https://images.pexels.com/photos/35351659/pexels-photo-35351659.jpeg', alt: 'Crispy masala dosa with chutney' },
  { url: 'https://images.pexels.com/photos/35539315/pexels-photo-35539315.jpeg', alt: 'South Indian breakfast spread' },
  { url: 'https://images.pexels.com/photos/31199041/pexels-photo-31199041.jpeg', alt: 'Idli with sambar and chutney' },
  { url: 'https://images.pexels.com/photos/941869/pexels-photo-941869.jpeg', alt: 'Indian dishes platter' },
  { url: 'https://images.pexels.com/photos/17869140/pexels-photo-17869140.jpeg', alt: 'Uttapam with chutney' },
  { url: 'https://images.pexels.com/photos/29707937/pexels-photo-29707937.jpeg', alt: 'Warmly lit restaurant interior' },
];

export const SERVICES = [
  {
    id: 'dine-in',
    title: 'Dine In',
    description:
      'Sit back in our warm, welcoming dining room and enjoy a freshly cooked South Indian feast.',
  },
  {
    id: 'takeaway',
    title: 'Takeaway',
    description:
      'Order ahead and pick up at your convenience — packed hot and ready to go.',
  },
  {
    id: 'delivery',
    title: 'Delivery',
    description:
      'Authentic dosas, biryani and curries delivered straight to your door across the Sunshine Coast.',
  },
];

export const LEGACY_STATS = [
  { value: '250+', label: 'Locations Worldwide' },
  { value: '40+', label: 'Years of Heritage' },
  { value: '1', label: 'Guinness World Record' },
];

export const TESTIMONIALS = [
  {
    name: 'Aarav P.',
    rating: 5,
    quote:
      'The masala dosa is the best I’ve had outside of Bangalore. Warm welcome, generous portions and the sambar is unbelievable.',
  },
  {
    name: 'Sophie M.',
    rating: 5,
    quote:
      'A proper hidden gem on Kingsford Smith Parade. The biryani was fragrant and the staff went above and beyond.',
  },
  {
    name: 'James & Priya',
    rating: 5,
    quote:
      'Booked for our anniversary — the team made us feel like family. Tandoori platter is a must.',
  },
  {
    name: 'Liam R.',
    rating: 5,
    quote:
      'Brilliant vegetarian options, beautifully spiced. Takeaway arrived hot and packed with care.',
  },
];
